import { useTranslation } from 'react-i18next'

import { getDateFnsLocale } from '@/lib/dateFnsLocale'

/**
 * Returns the date-fns locale matching the current i18n language.
 * Use this when calling date-fns formatting functions that accept a locale option.
 *
 * @example
 * const locale = useDateFnsLocale()
 * const dateStr = formatDistanceToNow(date, { addSuffix: true, locale })
 */
export function useDateFnsLocale() {
  const { i18n } = useTranslation()
  return getDateFnsLocale(i18n.language)
}
